import { VectorTile } from '@mapbox/vector-tile';
import Protobuf from 'pbf';

import pick from 'lodash/pick';
import { drawAmenitiesIcon } from '../../../util/mapIconUtils';
import { isBrowser } from '../../../util/browser';
import { getAmenityType } from '../../../util/mapLayerUtils';

const showFacilities = 14;

export default class Amenities {
  constructor(tile, config) {
    this.tile = tile;
    this.config = config;
    const scaleratio = (isBrowser && window.devicePixelRatio) || 1;
    this.width = 16 * scaleratio;
    this.height = 16 * scaleratio;
    this.promise = this.getPromise();
  }

  static getName = () => 'amenities';

  getPromise() {
    return fetch(
      `${this.config.URL.AMENITIES_MAP.default}${
        this.tile.coords.z + (this.tile.props.zoomOffset || 0)
      }` + `/${this.tile.coords.x}/${this.tile.coords.y}.pbf`,
    ).then(res => {
      if (res.status !== 200) {
        return undefined;
      }

      if (!this.config.amenities.showNavigationCard) {
        return undefined;
      }

      return res.arrayBuffer().then(
        buf => {
          const vt = new VectorTile(new Protobuf(buf));

          this.features = [];

          if (
            this.tile.coords.z >= showFacilities &&
            vt.layers.facilities != null
          ) {
            for (
              let i = 0, ref = vt.layers.facilities.length - 1;
              i <= ref;
              i++
            ) {
              const feature = vt.layers.facilities.feature(i);
              [[feature.geom]] = feature.loadGeometry();
              this.features.push(pick(feature, ['geom', 'properties']));
              drawAmenitiesIcon(
                getAmenityType(feature.properties),
                this.tile,
                feature.geom,
                this.width,
                this.height,
              );
            }
          }
        },
        err => console.log(err),
      );
    });
  }
}
